module.exports = __webpack_public_path__ + "img/e13a644.jpg";